export function setClass(element: HTMLElement, condition: boolean, className: string) {
	if (condition) element.classList.add(className);
	else element.classList.remove(className);
}
